<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Calculation.Title }}
            <span class="subtitle hero-subtitle">{{ $lang.Calculation.NewTitle_3 }}</span>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-catalog-request" icon-left="plus-box-outline" @click="openCircuitDevices">{{ [$lang.Calculation.InnerTitle_14, $lang.Calculation.InnerTitle_15, $lang.Calculation.InnerTitle_16].join(' ') }}</b-button>
            </p>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body calc-body">
                <calculationTabs />
                <outputCircBtns />

                <!-- The circuit being put together: its name, current, RDF and how many there are. -->
                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_14 }}</p>
                    <div class="calc-grid">
                        <b-field :label="$lang.CalcCircInfos.CircuitDef" :type="{ 'is-danger': hasError_circuitDefinition }" :message="hasError_circuitDefinition ? $lang.Menus.EmptyWarning : ''">
                            <b-input v-model="circuitDefinition"></b-input>
                        </b-field>
                        <b-field :type="{ 'is-danger': hasError_ratedCurrent }" :message="hasError_ratedCurrent ? $lang.Menus.EmptyWarning : ''">
                            <template #label><span v-html="$lang.CalcCircInfos.CircuitRatedCurr"></span></template>
                            <b-select v-model="ratedCurrent" expanded @input="setIng">
                                <option v-for="option in ratedCurrentList" :value="option.CurrentVal" :key="option.CurrentVal">{{ option.CurrentVal }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.RDF" :type="{ 'is-danger': hasError_rdf }" :message="hasError_rdf ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="rdf" expanded @input="setIng">
                                <option v-for="option in rdfList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Ing"></span></template>
                            <b-input v-model="Ing" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.CircuitNumber" :type="{ 'is-danger': hasError_numberOfCircuits || hasError_numberOfCircuits2 }" :message="hasError_numberOfCircuits ? $lang.Menus.EmptyWarning : (hasError_numberOfCircuits2 ? $lang.OtherDialog.Message_1 : '')">
                            <b-input v-model="numberOfCircuits" type="number" step="1" min="1" @input="controlNumOfCircuits()"></b-input>
                        </b-field>
                    </div>
                </div>

                <!-- Its devices, each level appearing once the catalogue has a choice for it. -->
                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_9 }}</p>
                    <div class="calc-grid">
                        <b-field :label="$lang.CalcCircInfos.Type" :type="{ 'is-danger': hasError_type }" :message="hasError_type ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="type" expanded @input="getCircuitDevice_Brands">
                                <option v-for="option in typesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Brand" :type="{ 'is-danger': hasError_brand }" :message="hasError_brand ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="brand" expanded @input="getCircuitDevice_Codes">
                                <option v-for="option in brandsList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Code" :type="{ 'is-danger': hasError_code }" :message="hasError_code ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="code" expanded @input="getCircuitDevice_Ins">
                                <option v-for="option in codesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isIn_AVisible" :type="{ 'is-danger': hasError_in_A }" :message="hasError_in_A ? $lang.Menus.EmptyWarning : ''">
                            <template #label><span v-html="$lang.CalcCircInfos.In_A"></span></template>
                            <b-select v-model="in_A" expanded @input="getCircuitDevice_Pole">
                                <option v-for="option in in_valList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPoleNumVisible" :label="$lang.CalcCircInfos.PoleNumber" :type="{ 'is-danger': hasError_poleNumber }" :message="hasError_poleNumber ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="poleNumber" expanded @input="getCircuitDevice_Sbt_Cekmeceli">
                                <option v-for="option in poleList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="is_sbt_cekmeceliVisible" :label="$lang.CalcCircInfos.Sbt_cekmeceli" :type="{ 'is-danger': hasError_sbt_cekmeceli }" :message="hasError_sbt_cekmeceli ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="sbt_cekmeceli" expanded @input="getCircuitDevice_Power">
                                <option v-for="option in sbt_cekmeceliList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPowerVisible" :label="$lang.CalcCircInfos.Power" :type="{ 'is-danger': hasError_power }" :message="hasError_power ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="power" expanded @input="getCircuitDevice_Pv">
                                <option v-for="option in powerList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                    </div>
                    <div class="calc-actions">
                        <b-button type="is-success" :label="$lang.CalcCircInfos.AddButton" :disabled="isButtonDisabled" @click="addToOutputCircuitCalcDevices" />
                    </div>
                    <b-table v-if="circuitcalculationdevicesdata.length" class="data-table" :data="circuitcalculationdevicesdata">
                        <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                            {{ props.row.Definition }}
                        </b-table-column>
                        <b-table-column field="Type" :label="$lang.CalcCircInfos.Type" v-slot="props">
                            {{ props.row.Type }}
                        </b-table-column>
                        <b-table-column field="Brand" :label="$lang.CalcCircInfos.Brand" v-slot="props">
                            {{ props.row.Brand }}
                        </b-table-column>
                        <b-table-column field="Code" :label="$lang.CalcCircInfos.Code" v-slot="props">
                            {{ props.row.Code }}
                        </b-table-column>
                        <b-table-column field="In_Value">
                            <template v-slot:header=""><span v-html="$lang.CalcCircInfos.In_A"></span></template>
                            <template v-slot="props">{{ props.row.In_Value }}</template>
                        </b-table-column>
                        <b-table-column field="Pole" :label="$lang.CalcCircInfos.PoleNumber" v-slot="props">
                            {{ props.row.Pole }}
                        </b-table-column>
                        <b-table-column field="Sbt_Cekmeceli" :label="$lang.CalcCircInfos.Sbt_cekmeceli" v-slot="props">
                            {{ props.row.Sbt_Cekmeceli }}
                        </b-table-column>
                        <b-table-column field="Power" :label="$lang.CalcCircInfos.Power" v-slot="props">
                            {{ props.row.Power }}
                        </b-table-column>
                        <b-table-column field="Pv" :label="$lang.CalcCircInfos.Pv" v-slot="props" numeric>
                            {{ getPvCalculated(props.row.Pv, props.row.RDF) }}
                        </b-table-column>
                        <b-table-column field="Action" v-slot="props" width="164">
                            <div class="row-actions">
                                <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateModal_OutputCircuitCalcDevices(props.row)">
                                    <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                </button>
                                <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromOutputCircuitCalcDevices(props.row)">
                                    <span class="mdi mdi-delete" aria-hidden="true"></span>
                                </button>
                                <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromOutputCircuitCalcDevices(props.row)">
                                    <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                </button>
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <!-- The devices' connecting conductors. -->
                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_10 }}</p>
                    <div class="calc-grid">
                        <b-field :label="$lang.CalcCircInfos.ConnType" :type="{ 'is-danger': hasError_connType }" :message="hasError_connType ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="connType" expanded @input="getCablePositions">
                                <option v-for="option in connTypeList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isCablePosVisible" :label="$lang.CalcCircInfos.CablePos" :type="{ 'is-danger': hasError_cablePos }" :message="hasError_cablePos ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="cablePos" expanded @input="getConductorDimensions">
                                <option v-for="option in cablePosList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber" :type="{ 'is-danger': hasError_phaseNumber_conductor }" :message="hasError_phaseNumber_conductor ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="phaseNumber_conductor" expanded>
                                <option v-for="option in phaseNumber_conductor_List" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorDimension" :type="{ 'is-danger': hasError_conductorDimension }" :message="hasError_conductorDimension ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="conductorDimension" expanded @input="getConductor_Imax_and_Power">
                                <option v-for="option in condDimensionList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_conductorLength }" :message="hasError_conductorLength ? (conductorLength === '' ? $lang.Menus.EmptyWarning : $lang.Menus.PositiveWarning) : ''">
                            <b-input v-model="conductorLength" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_conductor" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_conductor" type="number" disabled></b-input>
                        </b-field>
                    </div>
                    <div class="calc-actions">
                        <b-button type="is-success" :label="$lang.CalcCircInfos.AddButton" @click="addToOutputCircuitDeviceConductors" />
                    </div>
                    <b-table v-if="circuitdeviceconductorsdata.length" class="data-table" :data="circuitdeviceconductorsdata">
                        <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                            {{ props.row.Definition }}
                        </b-table-column>
                        <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" v-slot="props">
                            {{ props.row.ConnectionType }}
                        </b-table-column>
                        <b-table-column v-if="pendingConductorCable" field="CablePosition" :label="$lang.CalcCircInfos.CablePos" v-slot="props">
                            {{ props.row.CablePosition }}
                        </b-table-column>
                        <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" v-slot="props">
                            {{ props.row.PhaseNumber }}
                        </b-table-column>
                        <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" v-slot="props">
                            {{ props.row.DimensionInfo }}
                        </b-table-column>
                        <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" v-slot="props" numeric>
                            {{ props.row.ConductorLength }}
                        </b-table-column>
                        <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" v-slot="props" numeric>
                            {{ props.row.ConductorTemperature }}
                        </b-table-column>
                        <b-table-column field="MaxTemperature" numeric>
                            <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <template v-slot="props">{{ props.row.MaxTemperature }}</template>
                        </b-table-column>
                        <b-table-column field="I_Max" numeric>
                            <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <template v-slot="props">{{ truncate(props.row.I_Max, 1) }}</template>
                        </b-table-column>
                        <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" v-slot="props" numeric>
                            {{ truncate(props.row.LostPower, 1) }}
                        </b-table-column>
                        <b-table-column field="P_CalcResult" numeric>
                            <template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>
                            <template v-slot="props">{{ truncate(props.row.P_CalcResult, 1) }}</template>
                        </b-table-column>
                        <b-table-column field="Action" v-slot="props" width="164">
                            <div class="row-actions">
                                <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateModal_OutputCircuitDeviceConductors(props.row)">
                                    <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                </button>
                                <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromOutputCircuitDeviceConductors(props.row)">
                                    <span class="mdi mdi-delete" aria-hidden="true"></span>
                                </button>
                                <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromOutputCircuitDeviceConductors(props.row)">
                                    <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                </button>
                            </div>
                        </b-table-column>
                    </b-table>
                </div>

                <!-- Its sub-distribution busbar. -->
                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_11 }}</p>
                    <div class="calc-grid">
                        <b-field :label="$lang.CalcCircInfos.ConnType" :type="{ 'is-danger': hasError_connType_2 }" :message="hasError_connType_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="connType_2" expanded @input="getCablePositions_2">
                                <option v-for="option in connTypeList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isCablePosVisible_2" :label="$lang.CalcCircInfos.CablePos" :type="{ 'is-danger': hasError_cablePos_2 }" :message="hasError_cablePos_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="cablePos_2" expanded @input="getConductorDimensions_2">
                                <option v-for="option in cablePosList_2" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber" :type="{ 'is-danger': hasError_phaseNumber_conductor_2 }" :message="hasError_phaseNumber_conductor_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="phaseNumber_conductor_2" expanded>
                                <option v-for="option in phaseNumber_conductor_List_2" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorDimension" :type="{ 'is-danger': hasError_conductorDimension_2 }" :message="hasError_conductorDimension_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="conductorDimension_2" expanded @input="getConductor_Imax_and_Power_2">
                                <option v-for="option in condDimensionList_2" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_conductorLength_2 }" :message="hasError_conductorLength_2 ? (conductorLength_2 === '' ? $lang.Menus.EmptyWarning : $lang.Menus.PositiveWarning) : ''">
                            <b-input v-model="conductorLength_2" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_conductor_2" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_conductor_2" type="number" disabled></b-input>
                        </b-field>
                    </div>
                    <div class="calc-actions">
                        <b-button type="is-success" :label="$lang.CalcCircInfos.AddButton" @click="addToOutputCircuit_SubDistributionBusbars" />
                    </div>
                    <b-table v-if="subdistributionbusbarsdata.length" class="data-table" :data="subdistributionbusbarsdata">
                        <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                            {{ props.row.Definition }}
                        </b-table-column>
                        <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" v-slot="props">
                            {{ props.row.ConnectionType }}
                        </b-table-column>
                        <b-table-column v-if="pendingBusbarCable" field="CablePosition" :label="$lang.CalcCircInfos.CablePos" v-slot="props">
                            {{ props.row.CablePosition }}
                        </b-table-column>
                        <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" v-slot="props">
                            {{ props.row.PhaseNumber }}
                        </b-table-column>
                        <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" v-slot="props">
                            {{ props.row.DimensionInfo }}
                        </b-table-column>
                        <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" v-slot="props" numeric>
                            {{ props.row.ConductorLength }}
                        </b-table-column>
                        <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" v-slot="props" numeric>
                            {{ props.row.ConductorTemperature }}
                        </b-table-column>
                        <b-table-column field="MaxTemperature" numeric>
                            <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <template v-slot="props">{{ props.row.MaxTemperature }}</template>
                        </b-table-column>
                        <b-table-column field="I_Max" numeric>
                            <template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <template v-slot="props">{{ truncate(props.row.I_Max, 1) }}</template>
                        </b-table-column>
                        <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" v-slot="props" numeric>
                            {{ truncate(props.row.LostPower, 1) }}
                        </b-table-column>
                        <b-table-column field="P_CalcResult" numeric>
                            <template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>
                            <template v-slot="props">{{ truncate(props.row.P_CalcResult, 1) }}</template>
                        </b-table-column>
                        <b-table-column field="Action" v-slot="props" width="164">
                            <div class="row-actions">
                                <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateModal_OutputCircuit_SubDistributionBusbars(props.row)">
                                    <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                </button>
                                <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromOutputCircuit_SubDistributionBusbars(props.row)">
                                    <span class="mdi mdi-delete" aria-hidden="true"></span>
                                </button>
                                <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromOutputCircuit_SubDistributionBusbars(props.row)">
                                    <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                </button>
                            </div>
                        </b-table-column>
                    </b-table>
                    <p class="calc-note">{{ $lang.CalcCircInfos.SubDistrBusbarWarning }}</p>
                </div>

                <!-- The circuit is worked out and saved; the form then starts a new one. -->
                <div class="calc-actions">
                    <b-button type="is-primary" :label="$lang.CalcCircInfos.CalcAddButton" @click="calculateThenAddAll" />
                    <b-button :label="$lang.CalcCircInfos.AddNewCircuit" @click="setForNewCircuit" />
                </div>

                <!-- The saved circuits: a row per circuit, its items under it on a click. -->
                <template v-if="circuitcalculationdevicesdata_detailed.length || circuitdeviceconductorsdata_detailed.length || subdistributionbusbarsdata_detailed.length">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_7 }}</p>
                    <div class="calc-table-card">
                        <b-table v-if="circuitcalculationdevicesdata_detailed.length" class="data-table is-flush" style="--table-min: 1180px" :data="circuitcalculationdevicesdata_detailed" detailed custom-detail-row :show-detail-icon="false" detail-key="CircuitIndex">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                <a class="detail-toggle" @click="props.toggleDetails(props.row)">{{ props.row.Definition }}</a>
                            </b-table-column>
                            <b-table-column field="NumOfCircuits" :label="$lang.CalcCircInfos.AmountTitle" v-slot="props" width="64" numeric>{{ props.row.NumOfCircuits }}</b-table-column>
                            <b-table-column field="Type" :label="$lang.CalcCircInfos.Type" width="">-</b-table-column>
                            <b-table-column field="Brand" :label="$lang.CalcCircInfos.Brand" width="90">-</b-table-column>
                            <b-table-column field="Code" :label="$lang.CalcCircInfos.Code" width="">-</b-table-column>
                            <b-table-column field="In_Value" width="64" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.In_A"></span></template>-</b-table-column>
                            <b-table-column field="Pole" :label="$lang.CalcCircInfos.PoleNumber" width="70">-</b-table-column>
                            <b-table-column field="Sbt_Cekmeceli" :label="$lang.CalcCircInfos.Sbt_cekmeceli" width="90">-</b-table-column>
                            <b-table-column field="Power" :label="$lang.CalcCircInfos.Power" width="70">-</b-table-column>
                            <b-table-column field="RDF" :label="$lang.CalcCircInfos.RDF" v-slot="props" width="56" numeric>{{ props.row.RDF }}</b-table-column>
                            <b-table-column field="P_CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult2"></span></template>-</b-table-column>
                            <b-table-column field="Action" v-slot="props" width="116">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.CalcCircInfos.UpdateCircuit" @click="openUpdateModal_OutputCircuits(props.row, 1)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFrom_OutputCircuits(props.row)">
                                        <span class="mdi mdi-delete" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                            <template slot="detail" slot-scope="props">
                                <tr v-for="(item, i) in props.row.Devices" :key="'d' + i" class="detail-row">
                                    <td>{{ item.Definition }}</td>
                                    <td class="has-text-right">{{ item.NumOfCircuits }}</td>
                                    <td>{{ item.Type }}</td>
                                    <td>{{ item.Brand }}</td>
                                    <td>{{ item.Code }}</td>
                                    <td class="has-text-right">{{ item.In_Value }}</td>
                                    <td>{{ item.Pole }}</td>
                                    <td>{{ item.Sbt_Cekmeceli }}</td>
                                    <td>{{ item.Power }}</td>
                                    <td class="has-text-right">{{ item.RDF }}</td>
                                    <td class="has-text-right">{{ truncate(item.P_CalcResult, 1) }}</td>
                                    <td>
                                        <div class="row-actions">
                                            <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateModal_OutputCircuitCalcDevices_2(item, props.row)">
                                                <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                            </button>
                                            <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromOutputCircuitCalcDevices_2(item)">
                                                <span class="mdi mdi-delete" aria-hidden="true"></span>
                                            </button>
                                            <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromOutputCircuitCalcDevices_2(item, props.row)">
                                                <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </b-table>
                        <b-table v-if="circuitdeviceconductorsdata_detailed.length" class="data-table is-flush is-joined" style="--table-min: 1360px" :data="circuitdeviceconductorsdata_detailed" detailed custom-detail-row :show-detail-icon="false" detail-key="CircuitIndex">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                <a class="detail-toggle" @click="props.toggleDetails(props.row)">{{ props.row.Definition }}</a>
                            </b-table-column>
                            <b-table-column field="NumOfCircuits" :label="$lang.CalcCircInfos.AmountTitle" v-slot="props" width="64" numeric>{{ props.row.NumOfCircuits }}</b-table-column>
                            <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" width="100">-</b-table-column>
                            <b-table-column field="CablePosition" :label="$lang.CalcCircInfos.CablePos" width="100">-</b-table-column>
                            <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" width="60" numeric>-</b-table-column>
                            <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" width="90">-</b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" width="90" numeric>-</b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" width="80" numeric>-</b-table-column>
                            <b-table-column field="MaxTemperature" width="104" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>-</b-table-column>
                            <b-table-column field="I_Max" width="64" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>-</b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" width="80" numeric>-</b-table-column>
                            <b-table-column field="RDF" :label="$lang.CalcCircInfos.RDF" v-slot="props" width="56" numeric>{{ props.row.RDF }}</b-table-column>
                            <b-table-column field="P_CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>-</b-table-column>
                            <b-table-column field="Action" v-slot="props" width="116">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.CalcCircInfos.UpdateCircuit" @click="openUpdateModal_OutputCircuits(props.row, 2)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFrom_OutputCircuits(props.row)">
                                        <span class="mdi mdi-delete" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                            <template slot="detail" slot-scope="props">
                                <tr v-for="(item, i) in props.row.Devices" :key="'c' + i" class="detail-row">
                                    <td>{{ item.Definition }}</td>
                                    <td class="has-text-right">{{ item.NumOfCircuits }}</td>
                                    <td>{{ item.ConnectionType }}</td>
                                    <td>{{ item.CablePosition }}</td>
                                    <td class="has-text-right">{{ item.PhaseNumber }}</td>
                                    <td>{{ item.DimensionInfo }}</td>
                                    <td class="has-text-right">{{ item.ConductorLength }}</td>
                                    <td class="has-text-right">{{ item.ConductorTemperature }}</td>
                                    <td class="has-text-right">{{ item.MaxTemperature }}</td>
                                    <td class="has-text-right">{{ truncate(item.I_Max, 1) }}</td>
                                    <td class="has-text-right">{{ truncate(item.LostPower, 1) }}</td>
                                    <td class="has-text-right">{{ item.RDF }}</td>
                                    <td class="has-text-right">{{ truncate(item.P_CalcResult, 1) }}</td>
                                    <td>
                                        <div class="row-actions">
                                            <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateModal_OutputCircuitDeviceConductors_2(item, props.row)">
                                                <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                            </button>
                                            <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromOutputCircuitDeviceConductors_2(item)">
                                                <span class="mdi mdi-delete" aria-hidden="true"></span>
                                            </button>
                                            <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromOutputCircuitDeviceConductors_2(item, props.row)">
                                                <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </b-table>
                        <b-table v-if="subdistributionbusbarsdata_detailed.length" class="data-table is-flush is-joined" style="--table-min: 1300px" :data="subdistributionbusbarsdata_detailed" detailed custom-detail-row :show-detail-icon="false" detail-key="CircuitIndex">
                            <b-table-column field="Definition" :label="$lang.CalcCircInfos.Title_11" v-slot="props" cell-class="cell-strong">
                                <a class="detail-toggle" @click="props.toggleDetails(props.row)">{{ props.row.Definition }}</a>
                            </b-table-column>
                            <b-table-column field="NumOfCircuits" :label="$lang.CalcCircInfos.AmountTitle" width="64" numeric>1</b-table-column>
                            <b-table-column field="ConnectionType" :label="$lang.CalcCircInfos.ConnType" width="100">-</b-table-column>
                            <b-table-column field="CablePosition" :label="$lang.CalcCircInfos.CablePos" width="100">-</b-table-column>
                            <b-table-column field="PhaseNumber" :label="$lang.CalcCircInfos.PhaseNumber" width="60" numeric>-</b-table-column>
                            <b-table-column field="DimensionInfo" :label="$lang.CalcCircInfos.ConductorDimension" width="90">-</b-table-column>
                            <b-table-column field="ConductorLength" :label="$lang.CalcCircInfos.ConductorLength" width="90" numeric>-</b-table-column>
                            <b-table-column field="ConductorTemperature" :label="$lang.CalcCircInfos.ConductorTemp" width="80" numeric>-</b-table-column>
                            <b-table-column field="MaxTemperature" width="104" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>-</b-table-column>
                            <b-table-column field="I_Max" width="64" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.Imax"></span></template>-</b-table-column>
                            <b-table-column field="LostPower" :label="$lang.CalcCircInfos.LostPower" width="80" numeric>-</b-table-column>
                            <b-table-column field="P_CalcResult" width="84" numeric><template v-slot:header=""><span v-html="$lang.CalcCircInfos.CalcResult"></span></template>-</b-table-column>
                            <b-table-column field="Action" v-slot="props" width="116">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.CalcCircInfos.UpdateCircuit" @click="openUpdateModal_OutputCircuits(props.row, 3)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFrom_OutputCircuits(props.row)">
                                        <span class="mdi mdi-delete" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                            <template slot="detail" slot-scope="props">
                                <tr v-for="(item, i) in props.row.Devices" :key="'b' + i" class="detail-row">
                                    <td>{{ item.Definition }}</td>
                                    <td class="has-text-right">{{ item.NumOfCircuits }}</td>
                                    <td>{{ item.ConnectionType }}</td>
                                    <td>{{ item.CablePosition }}</td>
                                    <td class="has-text-right">{{ item.PhaseNumber }}</td>
                                    <td>{{ item.DimensionInfo }}</td>
                                    <td class="has-text-right">{{ item.ConductorLength }}</td>
                                    <td class="has-text-right">{{ item.ConductorTemperature }}</td>
                                    <td class="has-text-right">{{ item.MaxTemperature }}</td>
                                    <td class="has-text-right">{{ truncate(item.I_Max, 1) }}</td>
                                    <td class="has-text-right">{{ truncate(item.LostPower, 1) }}</td>
                                    <td class="has-text-right">{{ truncate(item.P_CalcResult, 1) }}</td>
                                    <td>
                                        <div class="row-actions">
                                            <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openUpdateModal_OutputCircuit_SubDistributionBusbars_2(item, props.row)">
                                                <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                            </button>
                                            <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromOutputCircuit_SubDistributionBusbars_2(item)">
                                                <span class="mdi mdi-delete" aria-hidden="true"></span>
                                            </button>
                                            <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromOutputCircuit_SubDistributionBusbars_2(item, props.row)">
                                                <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </b-table>
                        <div class="calc-total is-sub"><span>{{ $lang.CalcCircInfos.Total_P_OutputDevCond }}</span><b>{{ truncate(allTotal_P_1, 1) }}</b></div>
                        <div v-if="subdistributionbusbarsdata_detailed.length" class="calc-total is-sub"><span>{{ $lang.CalcCircInfos.Total_P_SubDistBusbars }}</span><b>{{ truncate(total_P_OutputCircuit_SubDistributionBusbars, 1) }}</b></div>
                        <div class="calc-total"><span>{{ $lang.CalcCircInfos.Total_P_OutputCircs }}</span><b>{{ truncate(allTotal_P_2, 1) }}</b></div>
                    </div>
                </template>
                <p class="calc-note">{{ $lang.CalcCircInfos.WarningInfo }}</p>
            </div>
        </div>

        <!-- The edit dialogs share the forms' fields; the forms are kept and given back. -->
        <b-modal v-model="isOutputCircuit_UpdateModalActive" has-modal-card @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ isDeviceConductor ? $lang.CalcCircInfos.UpdateDeviceConductor : (isSubDistrBusbar ? $lang.CalcCircInfos.UpdateSubBusbar : $lang.CalcCircInfos.UpdateCircuit) }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.CircuitDef" :type="{ 'is-danger': hasError_circuitDefinition }" :message="hasError_circuitDefinition ? $lang.Menus.EmptyWarning : ''">
                            <b-input v-model="circuitDefinition"></b-input>
                        </b-field>
                        <b-field v-if="!isSubDistrBusbar" :label="$lang.CalcCircInfos.CircuitNumber" :type="{ 'is-danger': hasError_numberOfCircuits2 }" :message="hasError_numberOfCircuits2 ? $lang.OtherDialog.Message_1 : ''">
                            <b-input v-model="numberOfCircuits" type="number" step="1" min="1" @input="controlNumOfCircuits()"></b-input>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeCircuitModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="update_OutputCircuits()" />
                </footer>
            </div>
        </b-modal>

        <b-modal v-model="isCalcDevice_UpdateModalActive" has-modal-card @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.CalcCircInfos.UpdateDevice }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.Type" :type="{ 'is-danger': hasError_type }" :message="hasError_type ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="type" expanded @input="getCircuitDevice_Brands">
                                <option v-for="option in typesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Brand" :type="{ 'is-danger': hasError_brand }" :message="hasError_brand ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="brand" expanded @input="getCircuitDevice_Codes">
                                <option v-for="option in brandsList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.Code" :type="{ 'is-danger': hasError_code }" :message="hasError_code ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="code" expanded @input="getCircuitDevice_Ins">
                                <option v-for="option in codesList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isIn_AVisible" :type="{ 'is-danger': hasError_in_A }" :message="hasError_in_A ? $lang.Menus.EmptyWarning : ''">
                            <template #label><span v-html="$lang.CalcCircInfos.In_A"></span></template>
                            <b-select v-model="in_A" expanded @input="getCircuitDevice_Pole">
                                <option v-for="option in in_valList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPoleNumVisible" :label="$lang.CalcCircInfos.PoleNumber" :type="{ 'is-danger': hasError_poleNumber }" :message="hasError_poleNumber ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="poleNumber" expanded @input="getCircuitDevice_Sbt_Cekmeceli">
                                <option v-for="option in poleList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="is_sbt_cekmeceliVisible" :label="$lang.CalcCircInfos.Sbt_cekmeceli" :type="{ 'is-danger': hasError_sbt_cekmeceli }" :message="hasError_sbt_cekmeceli ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="sbt_cekmeceli" expanded @input="getCircuitDevice_Power">
                                <option v-for="option in sbt_cekmeceliList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isPowerVisible" :label="$lang.CalcCircInfos.Power" :type="{ 'is-danger': hasError_power }" :message="hasError_power ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="power" expanded @input="getCircuitDevice_Pv">
                                <option v-for="option in powerList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeDeviceModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="updateDevice()" />
                </footer>
            </div>
        </b-modal>

        <b-modal v-model="isConductor_UpdateModalActive" has-modal-card @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.CalcCircInfos.UpdateDeviceConductor }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.ConnType" :type="{ 'is-danger': hasError_connType }" :message="hasError_connType ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="connType" expanded @input="getCablePositions">
                                <option v-for="option in connTypeList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isCablePosVisible" :label="$lang.CalcCircInfos.CablePos" :type="{ 'is-danger': hasError_cablePos }" :message="hasError_cablePos ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="cablePos" expanded @input="getConductorDimensions">
                                <option v-for="option in cablePosList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber" :type="{ 'is-danger': hasError_phaseNumber_conductor }" :message="hasError_phaseNumber_conductor ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="phaseNumber_conductor" expanded>
                                <option v-for="option in phaseNumber_conductor_List" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorDimension" :type="{ 'is-danger': hasError_conductorDimension }" :message="hasError_conductorDimension ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="conductorDimension" expanded @input="getConductor_Imax_and_Power">
                                <option v-for="option in condDimensionList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_conductorLength }" :message="hasError_conductorLength ? (conductorLength === '' ? $lang.Menus.EmptyWarning : $lang.Menus.PositiveWarning) : ''">
                            <b-input v-model="conductorLength" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_conductor" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_conductor" type="number" disabled></b-input>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeConductorModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="updateConductor()" />
                </footer>
            </div>
        </b-modal>

        <b-modal v-model="isSubDistributionBusbars_UpdateModalActive" has-modal-card @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.CalcCircInfos.UpdateSubBusbar }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.ConnType" :type="{ 'is-danger': hasError_connType_2 }" :message="hasError_connType_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="connType_2" expanded @input="getCablePositions_2">
                                <option v-for="option in connTypeList" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field v-if="isCablePosVisible_2" :label="$lang.CalcCircInfos.CablePos" :type="{ 'is-danger': hasError_cablePos_2 }" :message="hasError_cablePos_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="cablePos_2" expanded @input="getConductorDimensions_2">
                                <option v-for="option in cablePosList_2" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.PhaseNumber" :type="{ 'is-danger': hasError_phaseNumber_conductor_2 }" :message="hasError_phaseNumber_conductor_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="phaseNumber_conductor_2" expanded>
                                <option v-for="option in phaseNumber_conductor_List_2" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorDimension" :type="{ 'is-danger': hasError_conductorDimension_2 }" :message="hasError_conductorDimension_2 ? $lang.Menus.EmptyWarning : ''">
                            <b-select v-model="conductorDimension_2" expanded @input="getConductor_Imax_and_Power_2">
                                <option v-for="option in condDimensionList_2" :value="option" :key="option">{{ option }}</option>
                            </b-select>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorLength" :type="{ 'is-danger': hasError_conductorLength_2 }" :message="hasError_conductorLength_2 ? (conductorLength_2 === '' ? $lang.Menus.EmptyWarning : $lang.Menus.PositiveWarning) : ''">
                            <b-input v-model="conductorLength_2" step="any" @input="setPositiveNumber()"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.ConductorTemp">
                            <b-input v-model="conductorTemp" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Tmax_inPanel"></span></template>
                            <b-input v-model="Tmax_inPanel" type="number" disabled></b-input>
                        </b-field>
                        <b-field>
                            <template #label><span v-html="$lang.CalcCircInfos.Imax"></span></template>
                            <b-input v-model="Imax_conductor_2" type="number" disabled></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower">
                            <b-input v-model="lostPower_conductor_2" type="number" disabled></b-input>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeBusbarModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="updateBusbar()" />
                </footer>
            </div>
        </b-modal>

        <b-loading v-if="isLoading" :is-full-page="true" :active="true" :can-cancel="false"></b-loading>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { storeLossTotals } from '@/api/lossTotals';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import OutputCircBtns from '@/components/OutputCircBtns.vue';
    import CalculationTabs from '@/components/CalculationTabs.vue';
    import keepFormDuringEdit from '@/mixins/keepFormDuringEdit';

    // Unchosen: a select can hand back null as well as '', and null == '' is false.
    //
    // The cascade handlers return on an unchosen value. Vue's select v-model reports a change
    // by itself when a select's options change and its value is not among them, so a reset
    // (or a closed dialog giving the form back) called them with nothing chosen, and the
    // catalogue was asked for an empty type or id 0 - a 400 or 500 each.
    const isEmpty = (value) => value === '' || value === null || value === undefined;

    // A catalogue level the user chooses: one that has values, and not only "NA".
    const offersChoice = (list) => list.length > 0 && !(list.length == 1 && list[0] == 'NA');

    // The circuit under construction. Every edit dialog writes the row's circuit into these,
    // circuitIndex among them: after editing a saved circuit, the next rows added went into it.
    const CIRCUIT_FORM = ['circuitIndex', 'circuitDefinition', 'numberOfCircuits', 'rdf',
        'hasError_circuitDefinition', 'hasError_numberOfCircuits', 'hasError_numberOfCircuits2'];
    // What each edit dialog shares with its add form (see mixins/keepFormDuringEdit).
    const DEVICE_FORM = CIRCUIT_FORM.concat(['type', 'brand', 'code', 'in_A', 'poleNumber', 'sbt_cekmeceli', 'power', 'Pv',
        'brandsList', 'codesList', 'in_valList', 'poleList', 'sbt_cekmeceliList', 'powerList',
        'isIn_AVisible', 'isPoleNumVisible', 'is_sbt_cekmeceliVisible', 'isPowerVisible', 'isButtonDisabled',
        'hasError_type', 'hasError_brand', 'hasError_code', 'hasError_in_A', 'hasError_poleNumber', 'hasError_sbt_cekmeceli', 'hasError_power']);
    const CONDUCTOR_FORM = CIRCUIT_FORM.concat(['connType', 'cablePos', 'phaseNumber_conductor', 'conductorDimension', 'conductorLength',
        'Imax_conductor', 'lostPower_conductor', 'cablePosList', 'phaseNumber_conductor_List', 'condDimensionList', 'isCablePosVisible',
        'hasError_connType', 'hasError_cablePos', 'hasError_phaseNumber_conductor', 'hasError_conductorDimension', 'hasError_conductorLength']);
    const BUSBAR_FORM = CIRCUIT_FORM.concat(['connType_2', 'cablePos_2', 'phaseNumber_conductor_2', 'conductorDimension_2', 'conductorLength_2',
        'Imax_conductor_2', 'lostPower_conductor_2', 'cablePosList_2', 'phaseNumber_conductor_List_2', 'condDimensionList_2', 'isCablePosVisible_2',
        'hasError_connType_2', 'hasError_cablePos_2', 'hasError_phaseNumber_conductor_2', 'hasError_conductorDimension_2', 'hasError_conductorLength_2']);

    // A saved item's circuit, as the dialogs and copies take it from the circuit row.
    const circuitOf = (row) => ({ RDF: row.RDF, CircuitIndex: row.CircuitIndex, CircuitDefinition: row.Definition, NumOfCircuits: row.NumOfCircuits });

    export default {
        name: 'Calc_OutputCircuit',
        mixins: [keepFormDuringEdit],
        components: {
            VerticalStepBar,
            OutputCircBtns,
            CalculationTabs
        },
        data() {
            return {
                isActive: true,
                projectId: 0,
                isInfoOpened: false,
                busbarDimensionList: [],
                selectedBusbarDimension: '',
                isLoading: false,
                // The row not yet saved that an edit dialog is working on (null for a saved one).
                editingRow: null,
                reloadSeq: 0,
                Tmax_inPanel: 0,
                allTotal_P_1: 0,
                allTotal_P_2: 0,

                circuitDefinition: '',
                savedCircDef: '',
                circuitIndex: 0,
                ratedCurrent: 0,
                ratedCurrentList: [],
                rdf: 0.8,
                rdfList: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
                Ing: 0,
                numberOfCircuits: 1,
                isOutputCircuit_UpdateModalActive: false,
                hasError_circuitDefinition: false,
                hasError_ratedCurrent: false,
                hasError_rdf: false,
                hasError_numberOfCircuits: false,
                hasError_numberOfCircuits2: false,
                canCalculate: false,

                outputCircuitCalcDeviceId: 0,
                circuitcalculationdevicesdata: [],
                circuitcalculationdevicesdata_detailed: [],
                total_P_OutputCircuitCalcDevices: 0,
                definitionIndex: 1,
                device_definition: '',
                type: '',
                typesList: [],
                brand: '',
                brandsList: [],
                code: '',
                codesList: [],
                in_A: '',
                in_valList: [],
                poleNumber: 0,
                poleList: [],
                isPoleNumVisible: false,
                sbt_cekmeceli: '',
                sbt_cekmeceliList: [],
                is_sbt_cekmeceliVisible: false,
                power: 0,
                powerList: [],
                isPowerVisible: false,
                Pv: 0,
                pvList: [],
                PvResult: 0,
                isPv_Visible: false,
                isCalcDevice_UpdateModalActive: false,
                hasError_type: false,
                hasError_brand: false,
                hasError_code: false,
                hasError_in_A: false,
                hasError_poleNumber: false,
                emptyWarning_poleNumber: '',
                hasError_sbt_cekmeceli: false,
                emptyWarning_sbt_cekmeceli: '',
                hasError_power: false,
                emptyWarning_power: '',
                hasError_Pv: false,
                canCalculate_2: false,
                isIn_AVisible: false,

                circuitDeviceConductorId: 0,
                circuitdeviceconductorsdata: [],
                circuitdeviceconductorsdata_detailed: [],
                total_P_OutputCircuitDeviceConductors: 0,
                device_definition_2: '',
                connType: '',
                connTypeList: [],
                cablePos: '',
                isCablePosVisible: false,
                cablePosList: [],
                phaseNumber_conductor: '',
                phaseNumber_conductor_List: [],
                conductorDimension: '',
                condDimensionList: [],
                conductorLength: 1,
                conductorTemp: 70,
                Imax_conductor: 0,
                lostPower_conductor: 0,
                isConductor_UpdateModalActive: false,
                hasError_connType: false,
                hasError_cablePos: false,
                hasError_phaseNumber_conductor: false,
                hasError_conductorDimension: false,
                hasError_conductorLength: false,
                canCalculate_3: false,
                isSubDistrBusbar: false,
                isDeviceConductor: false,

                subDistributionBusbarId: 0,
                subdistributionbusbarsdata: [],
                subdistributionbusbarsdata_detailed: [],
                total_P_OutputCircuit_SubDistributionBusbars: 0,
                subDistributionBusbarsId: 1,
                device_definition_3: '',
                connType_2: '',
                cablePos_2: '',
                isCablePosVisible_2: false,
                cablePosList_2: [],
                phaseNumber_conductor_2: '',
                phaseNumber_conductor_List_2: [],
                conductorDimension_2: '',
                condDimensionList_2: [],
                conductorLength_2: 1,
                conductorTemp_2: 70,
                Imax_conductor_2: 0,
                lostPower_conductor_2: 0,
                isSubDistributionBusbars_UpdateModalActive: false,
                hasError_connType_2: false,
                hasError_cablePos_2: false,
                hasError_phaseNumber_conductor_2: false,
                hasError_conductorDimension_2: false,
                hasError_conductorLength_2: false,
                canCalculate_4: false,
                isButtonDisabled: false
            }
        },
        computed: {
            // The cable-position column follows the rows, not the add form.
            pendingConductorCable() {
                return this.circuitdeviceconductorsdata.some((row) => row.CablePosition);
            },
            pendingBusbarCable() {
                return this.subdistributionbusbarsdata.some((row) => row.CablePosition);
            }
        },
        mounted() {
            this.projectId = this.$store.state.projectId;
            this.Tmax_inPanel = this.$store.state.maxTemperature;

            this.getCircuitIndex();
            this.getRatedCurrentList();
            this.reloadSaved();
            this.getCircuitDevice_Types();
            this.setIng();
            this.getConnectionTypes();

            this.$store.state.activeStep = 3;
            this.$store.state.isFooterFixed = false;
        },
        watch: {
            $route() {

            }
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_InputCircuit');
            },
            submit() {
                this.saveResult();

                this.$store.isPageOpenedFromStepBar = false;
                this.$store.canResultOpen = true;

                router.push('/calc_Manuel');
            },
            // The whole tool's total, from the server: see api/lossTotals.js.
            saveResult() {
                return storeLossTotals(this.$store, this.projectId).catch(() => {});
            },
            // A choice clears itself and every level under it, and those levels stay hidden until
            // the catalogue answers. The resets ran a level low: a new code kept the old In, a new
            // In the old pole, and the next request went out with the stale value.
            resetFieldList_1(index) {
                const levels = [
                    ['brand', 'brandsList', null],
                    ['code', 'codesList', null],
                    ['in_A', 'in_valList', 'isIn_AVisible'],
                    ['poleNumber', 'poleList', 'isPoleNumVisible'],
                    ['sbt_cekmeceli', 'sbt_cekmeceliList', 'is_sbt_cekmeceliVisible'],
                    ['power', 'powerList', 'isPowerVisible']
                ];
                levels.slice(index - 1).forEach(([value, list, visible], i) => {
                    this[value] = '';
                    if (i > 0) {
                        this[list] = [];
                    }
                    if (visible) {
                        this[visible] = false;
                    }
                });
                this.Pv = 0;
            },
            // The same for a conductor (sfx '') or the busbar (sfx '_2'); I max and its loss follow
            // the section, so they go with it.
            resetConductorFrom(index, sfx) {
                if (index <= 1) {
                    this['cablePos' + sfx] = '';
                }
                if (index <= 2) {
                    this['phaseNumber_conductor' + sfx] = '';
                }
                this['conductorDimension' + sfx] = '';
                this['Imax_conductor' + sfx] = 0;
                this['lostPower_conductor' + sfx] = 0;
            },
            resetFieldList_2(index) {
                this.resetConductorFrom(index, '');
            },
            resetFieldList_3(index) {
                this.resetConductorFrom(index, '_2');
            },

            controlNumOfCircuits() {
                var tempNumberOfCircuits = this.numberOfCircuits + '';
                tempNumberOfCircuits = tempNumberOfCircuits.replace(/[^0-9]/g, '');
                this.numberOfCircuits = tempNumberOfCircuits;

                if (this.numberOfCircuits < 1) {
                    this.hasError_numberOfCircuits2 = true;
                } else {
                    this.hasError_numberOfCircuits2 = false;
                }
            },

            // The pending rows copied the circuit's RDF, count and name when each was added;
            // changing them afterwards saved the old values, and could mix RDFs in one circuit.
            // Stamp the circuit as it is now on every row, and redo the RDF-dependent P.
            stampPendingRows() {
                this.circuitcalculationdevicesdata.forEach((row) => {
                    row.RDF = this.rdf;
                    row.CircuitDefinition = this.circuitDefinition;
                    row.NumOfCircuits = this.numberOfCircuits;
                    row.P_CalcResult = this.get_P_Device_2(row.Pv, this.rdf);
                });
                this.circuitdeviceconductorsdata.forEach((row) => {
                    row.RDF = this.rdf;
                    row.CircuitDefinition = this.circuitDefinition;
                    row.NumOfCircuits = this.numberOfCircuits;
                    row.Definition = this.circuitDefinition + ' ' + this.$lang.OtherDialog.Conductor;
                    row.P_CalcResult = this.get_P_Conductor_2(row.LostPower, this.rdf, row.ConductorLength, row.PhaseNumber, row.ConnectionType);
                });
                this.subdistributionbusbarsdata.forEach((row) => {
                    row.RDF = this.rdf;
                    row.CircuitDefinition = this.circuitDefinition;
                    row.NumOfCircuits = this.numberOfCircuits;
                    row.Definition = this.circuitDefinition + ' ' + this.$lang.OtherDialog.Busbar;
                });
            },
            // The circuit needs its name, current, RDF and count, and at least one device; conductors
            // and a busbar are optional. It went by flags left from the last "Ekle" of each kind, so
            // a circuit with empty lists went through when an earlier one had set them.
            calculateThenAddAll() {
                if (this.numberOfCircuits < 1) {
                    this.$buefy.dialog.alert({
                        title: this.$lang.OtherDialog.Title_1,
                        message: this.$lang.OtherDialog.Message_1,
                        confirmText: this.$lang.OtherDialog.Confirm,
                        type: 'is-warning',
                        hasIcon: true
                    });
                    return;
                }
                this.controlInputs();
                if (!this.canCalculate || this.circuitcalculationdevicesdata.length == 0) {
                    this.$buefy.dialog.alert({
                        title: this.$lang.OtherDialog.Title_2,
                        message: this.$lang.OtherDialog.Message_2,
                        confirmText: this.$lang.OtherDialog.Confirm,
                        type: 'is-warning',
                        hasIcon: true
                    });
                    return;
                }

                this.stampPendingRows();
                this.isLoading = true;
                Promise.all([
                    api.panels.addToOutputCircuitCalcDevices_2({ DeviceArray: this.circuitcalculationdevicesdata }),
                    api.panels.addToOutputCircuitDeviceConductors_2({ DeviceArray: this.circuitdeviceconductorsdata }),
                    api.panels.addToOutputCircuit_SubDistributionBusbars_2({ DeviceArray: this.subdistributionbusbarsdata })
                ]).then((answers) => {
                    const failed = answers.find((res) => res.isError);
                    if (failed) {
                        // The form is kept: nothing the user entered is lost.
                        this.$buefy.dialog.alert(this.$errorModal(failed));
                    } else {
                        this.$buefy.toast.open(this.$lang.OtherDialog.Added);
                        this.savedCircDef = this.circuitDefinition;
                        this.setForNewCircuit();
                    }
                    return this.reloadSaved();
                }).finally(() => {
                    this.isLoading = false;
                });
            },

            getCircuitIndex() {
                this.circuitIndex = this.$store.state.circIndex;
                this.$store.state.circIndex = this.$store.state.circIndex + 1;
            },
            getRatedCurrentList() {
                this.ratedCurrentList = [];
                api.panels.getRatedCurrentList().then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.ratedCurrentList.push(e);
                        });
                    }
                });
            },
            setIng() {
                if (this.ratedCurrent == null) {
                    this.ratedCurrent = 0;
                }
                if (this.rdf == null) {
                    this.rdf = 0.8;
                }
                // Rounded: 6 x 0.8 showed as 4.800000000000001.
                this.Ing = Math.round(this.ratedCurrent * this.rdf * 1000) / 1000;
            },
            get_P_Device_2(_Pv, _RDF) {
                var deviceLostPower = _Pv * _RDF * _RDF;
                return deviceLostPower;
            },
            getCircuitDevice_Types() {
                this.typesList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Types(langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.typesList.push(e);
                        });
                    }
                });
            },
            getCircuitDevice_Brands() {
                if (isEmpty(this.type)) {
                    return;
                }
                this.brandsList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Brands(this.type, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.brandsList.push(e);
                        });
                    }
                });
                this.resetFieldList_1(1);
            },
            getCircuitDevice_Codes() {
                if (isEmpty(this.brand)) {
                    return;
                }
                this.codesList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Codes(this.brand, this.type, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.codesList.push(e);
                        });
                    }
                });
                this.resetFieldList_1(2);
            },
            getCircuitDevice_Ins() {
                if (isEmpty(this.code)) {
                    return;
                }
                this.in_valList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Ins(this.brand, this.type, this.code, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.in_valList.push(e);
                        });

                        if (this.in_valList.length > 0) {
                            this.isIn_AVisible = true;
                            if (this.in_valList.length == 1 && this.in_valList[0] == 'NA') {
                                this.isIn_AVisible = false;
                                this.in_A = 'NA';
                            }
                        } else {
                            this.isIn_AVisible = false;
                            this.in_A = 'NA';
                        }
                    }
                    if (this.in_A == 'NA') {
                        this.isButtonDisabled = true;
                        this.getCircuitDevice_Pole();
                    }
                });
                this.resetFieldList_1(3);
            },
            getCircuitDevice_Pole() {
                if (isEmpty(this.in_A)) {
                    return;
                }
                this.poleList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Pole(this.brand, this.type, this.code, this.in_A, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.poleList.push(e);
                        });
                        if (this.poleList.length > 0) {
                            this.isPoleNumVisible = true;
                            if (this.poleList.length == 1 && this.poleList[0] == 'NA') {
                                this.isPoleNumVisible = false;
                                this.poleNumber = 'NA';
                            }
                        } else {
                            this.isPoleNumVisible = false;
                            this.poleNumber = 'NA';
                        }
                        if (this.poleNumber == 'NA') {
                            this.isButtonDisabled = true;
                            this.getCircuitDevice_Sbt_Cekmeceli();
                        }
                    }
                });
                this.resetFieldList_1(4);
            },
            getCircuitDevice_Sbt_Cekmeceli() {
                if (isEmpty(this.poleNumber)) {
                    return;
                }
                this.sbt_cekmeceliList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Sbt_Cekmeceli(this.brand, this.type, this.code, this.in_A, this.poleNumber, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.sbt_cekmeceliList.push(e);
                        });
                        if (this.sbt_cekmeceliList.length > 0) {
                            this.is_sbt_cekmeceliVisible = true;
                            if (this.sbt_cekmeceliList.length == 1 && this.sbt_cekmeceliList[0] == 'NA') {
                                this.is_sbt_cekmeceliVisible = false;
                                this.sbt_cekmeceli = 'NA';
                            }
                        } else {
                            this.is_sbt_cekmeceliVisible = false;
                            this.sbt_cekmeceli = 'NA';
                        }

                        if (this.sbt_cekmeceli == 'NA') {
                            this.isButtonDisabled = true;
                            this.getCircuitDevice_Power();
                        }
                    }
                });
                this.resetFieldList_1(5);
            },
            getCircuitDevice_Power() {
                if (isEmpty(this.sbt_cekmeceli)) {
                    return;
                }
                this.powerList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Power(this.brand, this.type, this.code, this.in_A, this.poleNumber, this.sbt_cekmeceli, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.powerList.push(e);
                        });
                        if (this.powerList.length > 0) {
                            this.isPowerVisible = true;
                            if (this.powerList.length == 1 && this.powerList[0] == 'NA') {
                                this.isPowerVisible = false;
                                this.power = 'NA';
                            }
                        } else {
                            this.isPowerVisible = false;
                            this.power = 'NA';
                        }
                        if (this.power == 'NA') {
                            this.isButtonDisabled = true;
                            this.getCircuitDevice_Pv();
                        }
                    }
                });
                this.resetFieldList_1(6);
            },
            getCircuitDevice_Pv() {
                if (isEmpty(this.power)) {
                    return;
                }
                this.pvList = [];
                var langCode = this.$lang.Format.Lang;

                api.panels.getCircuitDevice_Pv(this.brand, this.type, this.code, this.in_A, this.poleNumber, this.sbt_cekmeceli, this.power, langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.pvList.push(e);
                        });
                        if (this.pvList.length > 0) {
                            this.isPv_Visible = true;
                            this.Pv = this.pvList[0];
                            this.PvResult = this.Pv * this.rdf;
                        } else {
                            this.isPv_Visible = false;
                            this.Pv = null;
                        }
                    }

                    if (this.Pv == null || this.Pv == 0) {
                        this.isButtonDisabled = true;
                    } else {
                        this.isButtonDisabled = false;
                    }
                });
            },
            // The saved circuits and every total, in one go, after anything that changes them. The
            // lists were reloaded one by one and the circuits' totals only with the devices, so
            // deleting a conductor or a busbar left the totals as they were; and a circuit with no
            // device never had its totals asked for.
            reloadSaved() {
                const seq = ++this.reloadSeq;
                const panels = api.panels;
                const id = this.projectId;
                return Promise.all([
                    panels.getOutputCircuitCalcDevices_Detailed(id),
                    panels.getOutputCircuitDeviceConductors_Detailed(id),
                    panels.get_OutputCircuit_SubDistributionBusbars_Detailed(id),
                    panels.getTotal_P_OutputCircuitCalculationDevices(id),
                    panels.getTotal_P_OutputCircuitDeviceConductors(id),
                    panels.getTotal_P_OutputCircuit_SubDistributionBusbars(id),
                    panels.getAllTotal_P_OutputCircuit(id)
                ]).then((answers) => {
                    // An older reload answering late does not overwrite a newer one.
                    if (seq !== this.reloadSeq) {
                        return;
                    }
                    const failed = answers.find((res) => res.isError);
                    if (failed) {
                        this.$buefy.dialog.alert(this.$errorModal(failed));
                        return;
                    }
                    const [devices, conductors, busbars, pDevices, pConductors, pBusbars, all] = answers.map((res) => res.data);
                    this.circuitcalculationdevicesdata_detailed = devices;
                    this.circuitdeviceconductorsdata_detailed = conductors;
                    this.subdistributionbusbarsdata_detailed = busbars;
                    this.total_P_OutputCircuitCalcDevices = pDevices;
                    this.total_P_OutputCircuitDeviceConductors = pConductors;
                    this.total_P_OutputCircuit_SubDistributionBusbars = pBusbars;
                    this.allTotal_P_1 = (all && all[0]) || 0;
                    this.allTotal_P_2 = (all && all[1]) || 0;
                    this.saveResult();
                });
            },
            getPvCalculated(pv, rdf) {
                var pvCalc = Math.pow(rdf, 2) * pv;
                return this.truncate(pvCalc, 1);
            },
            addToOutputCircuitCalcDevices() {
                this.controlInputs();
                this.controlInputs_2();
                if (this.canCalculate && this.canCalculate_2) {
                    const device = {
                        ProjectId: this.projectId,
                        Definition: this.$lang.OtherDialog.Device + this.definitionIndex,
                        Type: this.type,
                        Brand: this.brand,
                        Code: this.code,
                        In_Value: this.in_A,
                        Pole: this.poleNumber,
                        Sbt_Cekmeceli: this.sbt_cekmeceli,
                        Power: this.power,
                        Pv: this.Pv,
                        RDF: this.rdf,
                        P_CalcResult: this.get_P_Device_2(this.Pv, this.rdf),
                        CircuitIndex: this.circuitIndex,
                        CircuitDefinition: this.circuitDefinition,
                        NumOfCircuits: this.numberOfCircuits
                    };

                    this.circuitcalculationdevicesdata.push(device);
                    this.definitionIndex++;
                }
            },
            deleteFromOutputCircuitCalcDevices(row) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.removePending(this.circuitcalculationdevicesdata, row);
                        this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                    }
                })
            },
            deleteFromOutputCircuitCalcDevices_2(item) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>
                        api.panels.deleteFromOutputCircuitCalcDevices_2(item.Id).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                                this.reloadSaved();
                            }
                        })
                })
            },
            copyFromOutputCircuitCalcDevices(device) {
                var newDevice = {
                    ProjectId: device.ProjectId,
                    Definition: device.Definition + " " + this.$lang.CopyDialog.Extension,
                    Type: device.Type,
                    Brand: device.Brand,
                    Code: device.Code,
                    In_Value: device.In_Value,
                    Pole: device.Pole,
                    Sbt_Cekmeceli: device.Sbt_Cekmeceli,
                    Power: device.Power,
                    Pv: device.Pv,
                    RDF: device.RDF,
                    P_CalcResult: device.P_CalcResult,
                    CircuitIndex: device.CircuitIndex,
                    CircuitDefinition: device.CircuitDefinition,
                    NumOfCircuits: device.NumOfCircuits
                };
                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () => {
                        this.circuitcalculationdevicesdata.push(newDevice);
                        this.$buefy.toast.open(this.$lang.CopyDialog.Copied);
                    },
                    onCancel: () => {

                    }
                });
            },
            copyFromOutputCircuitCalcDevices_2(item, row) {
                var device2 = {
                    ProjectId: item.ProjectId,
                    Definition: item.Definition + " " + this.$lang.CopyDialog.Extension,
                    Type: item.Type,
                    Brand: item.Brand,
                    Code: item.Code,
                    In_Value: item.In_Value,
                    Pole: item.Pole,
                    Sbt_Cekmeceli: item.Sbt_Cekmeceli,
                    Power: item.Power,
                    Pv: item.Pv,
                    RDF: row.RDF,
                    P_CalcResult: this.get_P_Device_2(item.Pv, row.RDF),
                    CircuitIndex: row.CircuitIndex,
                    CircuitDefinition: row.Definition,
                    NumOfCircuits: row.NumOfCircuits
                }

                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.addToOutputCircuitCalcDevices(device2).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.CopyDialog.Copied);

                                this.reloadSaved();
                            }
                        }),
                })
            },
            // The dialogs open once the row's choices are in, each level fetched together (each
            // depends only on the row). The cascades they replace ran level by level: the saved
            // row's left out the language, the power level was shown the wrong way round, and a
            // failed step left the dialog half filled.
            openDeviceModal(device, circuit, pendingRow) {
                this.keepForm(DEVICE_FORM);
                this.isLoading = true;
                const lang = this.$lang.Format.Lang;
                const panels = api.panels;
                Promise.all([
                    panels.getCircuitDevice_Brands(device.Type, lang),
                    panels.getCircuitDevice_Codes(device.Brand, device.Type, lang),
                    panels.getCircuitDevice_Ins(device.Brand, device.Type, device.Code, lang),
                    panels.getCircuitDevice_Pole(device.Brand, device.Type, device.Code, device.In_Value, lang),
                    panels.getCircuitDevice_Sbt_Cekmeceli(device.Brand, device.Type, device.Code, device.In_Value, device.Pole, lang),
                    panels.getCircuitDevice_Power(device.Brand, device.Type, device.Code, device.In_Value, device.Pole, device.Sbt_Cekmeceli, lang)
                ]).then((answers) => {
                    const failed = answers.find((res) => res.isError);
                    if (failed) {
                        this.restoreForm();
                        this.$buefy.dialog.alert(this.$errorModal(failed));
                        return;
                    }
                    const [brands, codes, ins, poles, sbts, powers] = answers.map((res) => res.data);
                    this.brandsList = brands;
                    this.codesList = codes;
                    this.in_valList = ins;
                    this.poleList = poles;
                    this.sbt_cekmeceliList = sbts;
                    this.powerList = powers;
                    this.isIn_AVisible = offersChoice(ins);
                    this.isPoleNumVisible = offersChoice(poles);
                    this.is_sbt_cekmeceliVisible = offersChoice(sbts);
                    this.isPowerVisible = offersChoice(powers);

                    this.editingRow = pendingRow;
                    this.outputCircuitCalcDeviceId = device.Id;
                    this.device_definition = device.Definition;
                    this.type = device.Type;
                    this.brand = device.Brand;
                    this.code = device.Code;
                    this.in_A = device.In_Value;
                    this.poleNumber = device.Pole;
                    this.sbt_cekmeceli = device.Sbt_Cekmeceli;
                    this.power = device.Power;
                    this.Pv = device.Pv;
                    this.setCircuitFrom(circuit);
                    this.isCalcDevice_UpdateModalActive = true;
                }).finally(() => {
                    this.isLoading = false;
                });
            },
            setCircuitFrom(circuit) {
                this.rdf = circuit.RDF;
                this.circuitIndex = circuit.CircuitIndex;
                this.circuitDefinition = circuit.CircuitDefinition;
                this.numberOfCircuits = circuit.NumOfCircuits;
            },
            // A row not yet saved: its circuit is the one being put together.
            openUpdateModal_OutputCircuitCalcDevices(device) {
                this.openDeviceModal(device, device, device);
            },
            openUpdateModal_OutputCircuitCalcDevices_2(item, row) {
                this.openDeviceModal(item, circuitOf(row), null);
            },
            closeDeviceModal() {
                this.isCalcDevice_UpdateModalActive = false;
                this.editingRow = null;
                this.restoreForm();
            },
            // Checked as an add is; a row not yet saved is replaced where it is. Rows were found
            // by their definition, so an edit or a delete hit every row of the same name.
            updateDevice() {
                this.controlInputs_2();
                if (!this.canCalculate_2) {
                    return;
                }
                const device = {
                    ProjectId: this.projectId,
                    Definition: this.device_definition,
                    Type: this.type,
                    Brand: this.brand,
                    Code: this.code,
                    In_Value: this.in_A,
                    Pole: this.poleNumber,
                    Sbt_Cekmeceli: this.sbt_cekmeceli,
                    Power: this.power,
                    Pv: this.Pv,
                    RDF: this.rdf,
                    P_CalcResult: this.get_P_Device_2(this.Pv, this.rdf),
                    CircuitIndex: this.circuitIndex,
                    CircuitDefinition: this.circuitDefinition,
                    NumOfCircuits: this.numberOfCircuits
                };
                if (this.editingRow) {
                    this.replacePending(this.circuitcalculationdevicesdata, device);
                    return;
                }
                device.Id = this.outputCircuitCalcDeviceId;
                api.panels.updateOutputCircuitCalcDevices(device).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeDeviceModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.reloadSaved();
                    }
                });
            },
            replacePending(list, updated) {
                const i = list.indexOf(this.editingRow);
                if (i >= 0) {
                    list.splice(i, 1, updated);
                }
                this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                this.isCalcDevice_UpdateModalActive = false;
                this.isConductor_UpdateModalActive = false;
                this.isSubDistributionBusbars_UpdateModalActive = false;
                this.editingRow = null;
                this.restoreForm();
            },
            removePending(list, row) {
                const i = list.indexOf(row);
                if (i >= 0) {
                    list.splice(i, 1);
                }
            },

            getConnectionTypes() {
                this.connTypeList = [];
                var langCode = this.$lang.Format.Lang;
                api.panels.getConnectionTypes(langCode).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.connTypeList.push(e.typeName);
                        });

                        this.connType_2 = this.connTypeList[0];
                        this.getPhaseNumbers_2();
                        this.getConductorDimensions_2();
                    }
                });
            },
            getCablePositions() {
                if (isEmpty(this.connType)) {
                    return;
                }
                this.cablePosList = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                if (connTypeIndex == 2) {
                    this.isCablePosVisible = true;
                    var langCode = this.$lang.Format.Lang;
                    api.panels.getCablePositions(langCode).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            res.data.forEach((e) => {
                                this.cablePosList.push(e.positionName);
                            });
                        }
                    });
                } else {
                    this.isCablePosVisible = false;
                    this.getConductorDimensions();
                }
                this.getPhaseNumbers();
                this.resetFieldList_2(1);
            },
            getPhaseNumbers() {
                this.phaseNumber_conductor_List = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                api.panels.getPhaseNumbers(connTypeIndex).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.phaseNumber_conductor_List.push(e);
                        });
                    }
                });
                this.resetFieldList_2(2);
            },
            getConductorDimensions() {
                if ((this.isCablePosVisible && isEmpty(this.cablePos))) {
                    return;
                }
                this.condDimensionList = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                var cablePosId = this.cablePosList.indexOf(this.cablePos) + 1;
                api.panels.getConductorDimensions(connTypeIndex, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.condDimensionList.push(e.DimensionInfo);
                        });
                    }
                });
                this.resetFieldList_2(3);
            },
            getConductor_Imax_and_Power() {
                if (isEmpty(this.conductorDimension)) {
                    return;
                }
                this.getConductor_I_Max();
                this.getConductor_LostPower();
            },
            getConductor_I_Max() {
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                var dimensionId = this.condDimensionList.indexOf(this.conductorDimension) + 1;
                var cablePosId = this.cablePosList.indexOf(this.cablePos) + 1;
                api.panels.getConductor_I_Max(connTypeIndex, dimensionId, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.Imax_conductor = res.data;
                    }
                });
            },
            getConductor_LostPower() {
                var connTypeIndex = this.connTypeList.indexOf(this.connType) + 1;
                var dimensionId = this.condDimensionList.indexOf(this.conductorDimension) + 1;
                var cablePosId = this.cablePosList.indexOf(this.cablePos) + 1;
                api.panels.GetConductor_LostPower(connTypeIndex, dimensionId, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.lostPower_conductor = res.data;
                    }
                });
            },
            // connType: the connection type of the row being worked out - each caller passes its
            // own section's (or the copied row's). This read the conductor section's for every
            // caller, so a sub-distribution busbar came out at 0 W when that section was empty.
            get_P_Conductor_2(_Pv, Rdf, condLen, phaseNum, connType) {
                var deviceLostPower = 0;
                var connIndex = this.connTypeList.indexOf(connType) + 1;
                if (connIndex == 1) {
                    deviceLostPower = _Pv * Rdf * Rdf * condLen * phaseNum;
                }
                if (connIndex == 2) {
                    deviceLostPower = _Pv * Rdf * Rdf * condLen * phaseNum;
                }
                return deviceLostPower;
            },
            addToOutputCircuitDeviceConductors() {
                this.controlInputs();
                this.controlInputs_3();
                if (this.canCalculate && this.canCalculate_3) {
                    const device = {
                        ProjectId: this.projectId,
                        Definition: this.circuitDefinition + ' ' + this.$lang.OtherDialog.Conductor,
                        ConnectionType: this.connType,
                        CablePosition: this.cablePos,
                        PhaseNumber: this.phaseNumber_conductor,
                        DimensionInfo: this.conductorDimension,
                        ConductorLength: this.conductorLength,
                        ConductorTemperature: this.conductorTemp,
                        MaxTemperature: this.Tmax_inPanel,
                        I_Max: this.Imax_conductor,
                        LostPower: this.lostPower_conductor,
                        RDF: this.rdf,
                        P_CalcResult: this.get_P_Conductor_2(this.lostPower_conductor, this.rdf, this.conductorLength, this.phaseNumber_conductor, this.connType),
                        CircuitIndex: this.circuitIndex,
                        CircuitDefinition: this.circuitDefinition,
                        NumOfCircuits: this.numberOfCircuits
                    };
                    this.circuitdeviceconductorsdata.push(device);
                }
            },
            deleteFromOutputCircuitDeviceConductors(row) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.removePending(this.circuitdeviceconductorsdata, row);
                        this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                    }
                })
            },
            deleteFromOutputCircuitDeviceConductors_2(item) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>
                        api.panels.deleteFromOutputCircuitDeviceConductors_2(item.Id).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);

                                this.reloadSaved();
                            }
                        })
                })
            },
            copyFromOutputCircuitDeviceConductors(device) {
                var newDevice = {
                    ProjectId: this.projectId,
                    Definition: device.Definition + " " + this.$lang.CopyDialog.Extension,
                    ConnectionType: device.ConnectionType,
                    CablePosition: device.CablePosition,
                    PhaseNumber: device.PhaseNumber,
                    DimensionInfo: device.DimensionInfo,
                    ConductorLength: device.ConductorLength,
                    ConductorTemperature: device.ConductorTemperature,
                    MaxTemperature: device.MaxTemperature,
                    I_Max: device.I_Max,
                    LostPower: device.LostPower,
                    RDF: device.RDF,
                    P_CalcResult: device.P_CalcResult,
                    CircuitIndex: device.CircuitIndex,
                    CircuitDefinition: device.CircuitDefinition,
                    NumOfCircuits: device.NumOfCircuits
                };
                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () => {
                        this.circuitdeviceconductorsdata.push(newDevice);
                        this.$buefy.toast.open(this.$lang.CopyDialog.Copied);
                    },
                    onCancel: () => {

                    }
                });
            },
            copyFromOutputCircuitDeviceConductors_2(item, row) {
                var device2 = {
                    ProjectId: this.projectId,
                    Definition: item.Definition + " " + this.$lang.CopyDialog.Extension,
                    ConnectionType: item.ConnectionType,
                    CablePosition: item.CablePosition,
                    PhaseNumber: item.PhaseNumber,
                    DimensionInfo: item.DimensionInfo,
                    ConductorLength: item.ConductorLength,
                    ConductorTemperature: item.ConductorTemperature,
                    MaxTemperature: item.MaxTemperature,
                    I_Max: item.I_Max,
                    LostPower: item.LostPower,
                    RDF: row.RDF,
                    P_CalcResult: this.get_P_Conductor_2(item.LostPower, row.RDF, item.ConductorLength, item.PhaseNumber, item.ConnectionType),
                    CircuitIndex: row.CircuitIndex,
                    CircuitDefinition: row.Definition,
                    NumOfCircuits: row.NumOfCircuits
                }

                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.addToOutputCircuitDeviceConductors(device2).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.CopyDialog.Copied);

                                this.reloadSaved();
                            }
                        }),
                })
            },
            // A conductor's choices for a row: its cable positions and phase counts, then the
            // sections for its position. The dialogs asked for the sections before the positions
            // had arrived, so a cable row got the list for no position.
            loadConductorChoices(connType, cablePosition) {
                const panels = api.panels;
                const connTypeIndex = this.connTypeList.indexOf(connType) + 1;
                const isCable = connTypeIndex == 2;
                return Promise.all([
                    isCable ? panels.getCablePositions(this.$lang.Format.Lang) : Promise.resolve({ data: [] }),
                    panels.getPhaseNumbers(connTypeIndex)
                ]).then(([positions, phases]) => {
                    const failed = [positions, phases].find((res) => res.isError);
                    if (failed) {
                        throw failed;
                    }
                    const cablePositions = positions.data.map((e) => e.positionName);
                    const cablePosId = cablePositions.indexOf(cablePosition) + 1;
                    return panels.getConductorDimensions(connTypeIndex, cablePosId, this.Tmax_inPanel).then((dimensions) => {
                        if (dimensions.isError) {
                            throw dimensions;
                        }
                        return {
                            isCable,
                            cablePositions,
                            phases: phases.data,
                            dimensions: dimensions.data.map((e) => e.DimensionInfo)
                        };
                    });
                });
            },
            // sfx: '' for a device conductor, '_2' for a sub-distribution busbar.
            openConductorModal(sfx, keys, flag, device, circuit, pendingRow) {
                this.keepForm(keys);
                this.isLoading = true;
                this.loadConductorChoices(device.ConnectionType, device.CablePosition).then((choices) => {
                    this['cablePosList' + sfx] = choices.cablePositions;
                    this['isCablePosVisible' + sfx] = choices.isCable;
                    this['phaseNumber_conductor_List' + sfx] = choices.phases;
                    this['condDimensionList' + sfx] = choices.dimensions;

                    this.editingRow = pendingRow;
                    this['connType' + sfx] = device.ConnectionType;
                    this['cablePos' + sfx] = device.CablePosition;
                    this['phaseNumber_conductor' + sfx] = device.PhaseNumber;
                    this['conductorDimension' + sfx] = device.DimensionInfo;
                    this['conductorLength' + sfx] = device.ConductorLength;
                    this['Imax_conductor' + sfx] = device.I_Max;
                    this['lostPower_conductor' + sfx] = device.LostPower;
                    this.setCircuitFrom(circuit);
                    this[flag] = true;
                }).catch((res) => {
                    this.restoreForm();
                    this.$buefy.dialog.alert(this.$errorModal(res));
                }).finally(() => {
                    this.isLoading = false;
                });
            },
            openUpdateModal_OutputCircuitDeviceConductors(device) {
                this.openConductorModal('', CONDUCTOR_FORM, 'isConductor_UpdateModalActive', device, device, device);
            },
            openUpdateModal_OutputCircuitDeviceConductors_2(item, row) {
                this.circuitDeviceConductorId = item.Id;
                this.device_definition_2 = item.Definition;
                this.openConductorModal('', CONDUCTOR_FORM, 'isConductor_UpdateModalActive', item, circuitOf(row), null);
            },
            openUpdateModal_OutputCircuit_SubDistributionBusbars(device) {
                this.openConductorModal('_2', BUSBAR_FORM, 'isSubDistributionBusbars_UpdateModalActive', device, device, device);
            },
            openUpdateModal_OutputCircuit_SubDistributionBusbars_2(item, row) {
                this.subDistributionBusbarsId = item.Id;
                this.device_definition_3 = item.Definition;
                this.openConductorModal('_2', BUSBAR_FORM, 'isSubDistributionBusbars_UpdateModalActive', item, circuitOf(row), null);
            },
            closeConductorModal() {
                this.isConductor_UpdateModalActive = false;
                this.editingRow = null;
                this.restoreForm();
            },
            closeBusbarModal() {
                this.isSubDistributionBusbars_UpdateModalActive = false;
                this.editingRow = null;
                this.restoreForm();
            },
            updateConductor() {
                this.controlInputs_3();
                if (!this.canCalculate_3) {
                    return;
                }
                const device = {
                    ProjectId: this.projectId,
                    Definition: this.editingRow ? this.editingRow.Definition : this.device_definition_2,
                    ConnectionType: this.connType,
                    CablePosition: this.cablePos,
                    PhaseNumber: this.phaseNumber_conductor,
                    DimensionInfo: this.conductorDimension,
                    ConductorLength: this.conductorLength,
                    ConductorTemperature: this.conductorTemp,
                    MaxTemperature: this.Tmax_inPanel,
                    I_Max: this.Imax_conductor,
                    LostPower: this.lostPower_conductor,
                    RDF: this.rdf,
                    P_CalcResult: this.get_P_Conductor_2(this.lostPower_conductor, this.rdf, this.conductorLength, this.phaseNumber_conductor, this.connType),
                    CircuitIndex: this.circuitIndex,
                    CircuitDefinition: this.circuitDefinition,
                    NumOfCircuits: this.numberOfCircuits
                };
                if (this.editingRow) {
                    this.replacePending(this.circuitdeviceconductorsdata, device);
                    return;
                }
                device.Id = this.circuitDeviceConductorId;
                api.panels.updateOutputCircuitDeviceConductors(device).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeConductorModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.reloadSaved();
                    }
                });
            },
            updateBusbar() {
                this.controlInputs_4();
                if (!this.canCalculate_4) {
                    return;
                }
                const device = {
                    ProjectId: this.projectId,
                    Definition: this.editingRow ? this.editingRow.Definition : this.device_definition_3,
                    ConnectionType: this.connType_2,
                    CablePosition: this.cablePos_2,
                    PhaseNumber: this.phaseNumber_conductor_2,
                    DimensionInfo: this.conductorDimension_2,
                    ConductorLength: this.conductorLength_2,
                    ConductorTemperature: this.conductorTemp,
                    MaxTemperature: this.Tmax_inPanel,
                    I_Max: this.Imax_conductor_2,
                    LostPower: this.lostPower_conductor_2,
                    RDF: this.rdf,
                    P_CalcResult: this.get_P_Conductor(this.lostPower_conductor_2, this.conductorLength_2, this.phaseNumber_conductor_2, this.connType_2),
                    CircuitIndex: this.circuitIndex,
                    CircuitDefinition: this.circuitDefinition,
                    NumOfCircuits: this.numberOfCircuits
                };
                if (this.editingRow) {
                    this.replacePending(this.subdistributionbusbarsdata, device);
                    return;
                }
                device.Id = this.subDistributionBusbarsId;
                api.panels.updateOutputCircuit_SubDistributionBusbars(device).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeBusbarModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.reloadSaved();
                    }
                });
            },

            getCablePositions_2() {
                if (isEmpty(this.connType_2)) {
                    return;
                }
                this.cablePosList_2 = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType_2) + 1;
                if (connTypeIndex == 2) {
                    this.isCablePosVisible_2 = true;
                    var langCode = this.$lang.Format.Lang;
                    api.panels.getCablePositions(langCode).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            res.data.forEach((e) => {
                                this.cablePosList_2.push(e.positionName);
                            });
                        }
                    });
                } else {
                    this.isCablePosVisible_2 = false;
                    this.getConductorDimensions_2();
                }
                this.getPhaseNumbers_2();
                this.resetFieldList_3(1);
            },
            getPhaseNumbers_2() {
                this.phaseNumber_conductor_List_2 = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType_2) + 1;
                api.panels.getPhaseNumbers(connTypeIndex).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.phaseNumber_conductor_List_2.push(e);
                        });
                    }
                });
                this.resetFieldList_3(2);
            },
            getConductorDimensions_2() {
                if ((this.isCablePosVisible_2 && isEmpty(this.cablePos_2))) {
                    return;
                }
                this.condDimensionList_2 = [];
                var connTypeIndex = this.connTypeList.indexOf(this.connType_2) + 1;
                var cablePosId = this.cablePosList_2.indexOf(this.cablePos_2) + 1;
                api.panels.getConductorDimensions(connTypeIndex, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.condDimensionList_2.push(e.DimensionInfo);
                        });
                    }
                });
                this.resetFieldList_3(3);
            },
            getConductor_Imax_and_Power_2() {
                if (isEmpty(this.conductorDimension_2)) {
                    return;
                }
                this.getConductor_I_Max_2();
                this.getConductor_LostPower_2();
            },
            getConductor_I_Max_2() {
                var connTypeIndex = this.connTypeList.indexOf(this.connType_2) + 1;
                var dimensionId = this.condDimensionList_2.indexOf(this.conductorDimension_2) + 1;
                var cablePosId = this.cablePosList_2.indexOf(this.cablePos_2) + 1;
                api.panels.getConductor_I_Max(connTypeIndex, dimensionId, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.Imax_conductor_2 = res.data;
                    }
                });
            },
            getConductor_LostPower_2() {
                var connTypeIndex = this.connTypeList.indexOf(this.connType_2) + 1;
                var dimensionId = this.condDimensionList_2.indexOf(this.conductorDimension_2) + 1;
                var cablePosId = this.cablePosList_2.indexOf(this.cablePos_2) + 1;
                api.panels.GetConductor_LostPower(connTypeIndex, dimensionId, cablePosId, this.Tmax_inPanel).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.lostPower_conductor_2 = res.data;
                    }
                });
            },
            // connType: as for get_P_Conductor_2.
            get_P_Conductor(_Pv, condLen, phaseNum, connType) {
                var deviceLostPower = 0;
                var connIndex = this.connTypeList.indexOf(connType) + 1;
                if (connIndex == 1) {
                    deviceLostPower = _Pv * condLen * phaseNum;
                }
                if (connIndex == 2) {
                    deviceLostPower = _Pv * condLen * phaseNum;
                }
                return deviceLostPower;
            },
            addToOutputCircuit_SubDistributionBusbars() {
                this.controlInputs();
                this.controlInputs_4();
                if (this.canCalculate && this.canCalculate_4) {
                    const device = {
                        ProjectId: this.projectId,
                        Definition: this.circuitDefinition + ' ' + this.$lang.OtherDialog.Busbar,
                        ConnectionType: this.connType_2,
                        CablePosition: this.cablePos_2,
                        PhaseNumber: this.phaseNumber_conductor_2,
                        DimensionInfo: this.conductorDimension_2,
                        ConductorLength: this.conductorLength_2,
                        ConductorTemperature: this.conductorTemp,
                        MaxTemperature: this.Tmax_inPanel,
                        I_Max: this.Imax_conductor_2,
                        LostPower: this.lostPower_conductor_2,
                        RDF: this.rdf,
                        P_CalcResult: this.get_P_Conductor(this.lostPower_conductor_2, this.conductorLength_2, this.phaseNumber_conductor_2, this.connType_2),
                        CircuitIndex: this.circuitIndex,
                        CircuitDefinition: this.circuitDefinition,
                        NumOfCircuits: this.numberOfCircuits
                    };
                    this.subdistributionbusbarsdata.push(device);
                }
            },
            deleteFromOutputCircuit_SubDistributionBusbars(row) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.removePending(this.subdistributionbusbarsdata, row);
                        this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                    }
                })
            },
            deleteFromOutputCircuit_SubDistributionBusbars_2(item) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>
                        api.panels.deleteFromOutputCircuit_SubDistributionBusbars_2(item.Id).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);

                                this.reloadSaved();
                            }
                        })
                })
            },
            copyFromOutputCircuit_SubDistributionBusbars(device) {
                var newDevice = {
                    ProjectId: this.projectId,
                    Definition: device.Definition + " " + this.$lang.CopyDialog.Extension,
                    ConnectionType: device.ConnectionType,
                    CablePosition: device.CablePosition,
                    PhaseNumber: device.PhaseNumber,
                    DimensionInfo: device.DimensionInfo,
                    ConductorLength: device.ConductorLength,
                    ConductorTemperature: device.ConductorTemperature,
                    MaxTemperature: device.MaxTemperature,
                    I_Max: device.I_Max,
                    LostPower: device.LostPower,
                    RDF: device.RDF,
                    P_CalcResult: device.P_CalcResult,
                    CircuitIndex: device.CircuitIndex,
                    CircuitDefinition: device.CircuitDefinition,
                    NumOfCircuits: device.NumOfCircuits
                };
                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () => {
                        this.subdistributionbusbarsdata.push(newDevice);
                        this.$buefy.toast.open(this.$lang.CopyDialog.Copied);
                    },
                    onCancel: () => {

                    }
                });
            },
            copyFromOutputCircuit_SubDistributionBusbars_2(item, row) {
                var device2 = {
                    ProjectId: this.projectId,
                    Definition: item.Definition + " " + this.$lang.CopyDialog.Extension,
                    ConnectionType: item.ConnectionType,
                    CablePosition: item.CablePosition,
                    PhaseNumber: item.PhaseNumber,
                    DimensionInfo: item.DimensionInfo,
                    ConductorLength: item.ConductorLength,
                    ConductorTemperature: item.ConductorTemperature,
                    MaxTemperature: item.MaxTemperature,
                    I_Max: item.I_Max,
                    LostPower: item.LostPower,
                    RDF: row.RDF,
                    P_CalcResult: this.get_P_Conductor(item.LostPower, item.ConductorLength, item.PhaseNumber, item.ConnectionType),
                    CircuitIndex: row.CircuitIndex,
                    CircuitDefinition: row.Definition,
                    NumOfCircuits: row.NumOfCircuits
                }

                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.addToOutputCircuit_SubDistributionBusbars(device2).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.CopyDialog.Copied);

                                this.reloadSaved();
                            }
                        }),
                })
            },
            deleteFrom_OutputCircuits(row) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>
                        api.panels.deleteFrom_OutputCircuits(row.CircuitIndex, this.projectId).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);

                                this.reloadSaved();
                            }
                        })
                })
            },
            openUpdateModal_OutputCircuits(row, modalType) {
                this.keepForm(CIRCUIT_FORM);
                this.circuitIndex = row.CircuitIndex;
                this.circuitDefinition = row.Definition;
                this.numberOfCircuits = row.NumOfCircuits;
                this.hasError_circuitDefinition = false;
                this.hasError_numberOfCircuits2 = false;
                this.isDeviceConductor = modalType == 2;
                this.isSubDistrBusbar = modalType == 3;
                this.isOutputCircuit_UpdateModalActive = true;
            },
            closeCircuitModal() {
                this.isOutputCircuit_UpdateModalActive = false;
                this.restoreForm();
            },
            update_OutputCircuits() {
                // A name and a count of one or more; the dialog saved whatever it held.
                this.hasError_circuitDefinition = isEmpty(this.circuitDefinition) || this.circuitDefinition.toString().trim() === '';
                this.hasError_numberOfCircuits2 = !(parseInt(this.numberOfCircuits) >= 1);
                if (this.hasError_circuitDefinition || this.hasError_numberOfCircuits2) {
                    return;
                }
                var data = {
                    ProjectId: this.projectId,
                    CircuitIndex: this.circuitIndex,
                    CircuitDefinition: this.circuitDefinition,
                    NumOfCircuits: this.numberOfCircuits,
                };

                api.panels.update_OutputCircuits(data).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeCircuitModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.reloadSaved();
                    }
                })
            },

            setForNewCircuit() {
                this.Tmax_inPanel = this.$store.state.maxTemperature;

                this.getCircuitIndex();
                this.getRatedCurrentList();
                this.setIng();
                this.getConnectionTypes();

                this.rdf = 0.8;
                this.circuitDefinition = '';
                this.numberOfCircuits = 1;
                this.ratedCurrent = 0;
                // After the resets above: Ing kept the last circuit's value.
                this.setIng();
                this.isOutputCircuit_UpdateModalActive = false;

                this.circuitcalculationdevicesdata = [];
                this.total_P_OutputCircuitCalcDevices = 0;
                this.definitionIndex = 1;
                this.outputCircuitCalcDeviceId = 0;
                this.device_definition = '';
                this.brand = '';
                this.type = '';
                this.code = '';
                this.in_A = '';
                this.poleNumber = 0;
                this.sbt_cekmeceli = '';
                this.power = '';
                this.Pv = 0;
                this.isPoleNumVisible = false;
                this.is_sbt_cekmeceliVisible = false;
                this.isPowerVisible = false;
                this.isPv_Visible = false;
                this.isCalcDevice_UpdateModalActive = false;
                this.brandsList = [];
                this.resetFieldList_1(1);

                this.circuitDeviceConductorId = 0;
                this.circuitdeviceconductorsdata = [];
                this.total_P_OutputCircuitDeviceConductors = 0;
                this.device_definition_2 = '';
                this.connType = '';
                this.cablePos = '';
                this.phaseNumber_conductor = '';
                this.conductorDimension = '';
                this.conductorLength = 1;
                this.conductorTemp = 70;
                this.Imax_conductor = 0;
                this.lostPower_conductor = 0;
                this.isCablePosVisible = false;
                this.isConductor_UpdateModalActive = false;

                this.subdistributionbusbarsdata = [];
                this.subDistributionBusbarId = 0;
                this.total_P_OutputCircuit_SubDistributionBusbars = 0;
                this.subDistributionBusbarsId = 1;
                this.device_definition_3 = '';
                this.connType_2 = '';
                this.cablePos_2 = '';
                this.connType_2 = '';
                this.phaseNumber_conductor_2 = '';
                this.conductorDimension_2 = '';
                this.conductorLength_2 = 1;
                this.conductorTemp_2 = 70;
                this.Imax_conductor_2 = 0;
                this.lostPower_conductor_2 = 0;
                this.isCablePosVisible_2 = false;
                this.isSubDistributionBusbars_UpdateModalActive = false;
                // The last circuit's red marks went with it.
                Object.keys(this.$data).filter((key) => key.startsWith('hasError_')).forEach((key) => {
                    this[key] = false;
                });
            },

            setPositiveNumber() {
                if (this.conductorLength) {
                    this.conductorLength = parseFloat(this.conductorLength.toString().replace(',', '.'));
                }

                if (this.conductorLength_2) {
                    this.conductorLength_2 = parseFloat(this.conductorLength_2.toString().replace(',', '.'));
                }

                if (this.conductorLength < 0) {
                    this.conductorLength = 1;
                }

                if (this.conductorLength_2 < 0) {
                    this.conductorLength_2 = 1;
                }
            },
            truncate(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                if (theNumber.includes('.')) {
                    var pointIndex = theNumber.indexOf('.');
                    var _result = +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
                    var _resultString = _result.toString();
                    if (!_resultString.includes('.')) {
                        return _resultString + '.0';
                    } else {
                        return _result;
                    }
                } else {
                    return theNumber + '.0';
                }
            },
            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },
            controlInputs() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate = false;
                if (isEmpty(this.circuitDefinition)) {
                    this.hasError_circuitDefinition = true;
                } else if (this.ratedCurrent == 0) {
                    this.hasError_ratedCurrent = true;
                } else if (this.rdf == 0) {
                    this.hasError_rdf = true;
                } else if (this.numberOfCircuits == 0) {
                    this.hasError_numberOfCircuits = true;
                } else {
                    this.canCalculate = true;
                }

                if (!isEmpty(this.circuitDefinition)) {
                    this.hasError_circuitDefinition = false;
                }
                if (this.ratedCurrent != 0) {
                    this.hasError_ratedCurrent = false;
                }
                if (!isEmpty(this.rdf)) {
                    this.hasError_rdf = false;
                }
                if (this.numberOfCircuits != 0) {
                    this.hasError_numberOfCircuits = false;
                }
            },
            controlInputs_2() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate_2 = false;
                if (isEmpty(this.brand)) {
                    this.hasError_brand = true;
                } else if (isEmpty(this.type)) {
                    this.hasError_type = true;
                } else if (isEmpty(this.code)) {
                    this.hasError_code = true;
                } else if (isEmpty(this.in_A)) {
                    this.hasError_in_A = true;
                } else if (isEmpty(this.poleNumber)) {
                    if (this.isPoleNumVisible) {
                        this.hasError_poleNumber = true;
                        this.emptyWarning_poleNumber = this.$lang.Menus.EmptyWarning;
                    }
                } else if (isEmpty(this.sbt_cekmeceli)) {
                    if (this.is_sbt_cekmeceliVisible) {
                        this.hasError_sbt_cekmeceli = true;
                        this.emptyWarning_sbt_cekmeceli = this.$lang.Menus.EmptyWarning;
                    }
                } else if (isEmpty(this.power)) {
                    if (this.isPowerVisible) {
                        this.hasError_power = true;
                        this.emptyWarning_power = this.$lang.Menus.EmptyWarning;
                    }
                } else {
                    this.canCalculate_2 = true;
                }

                if (!isEmpty(this.type)) {
                    this.hasError_type = false;
                }
                if (!isEmpty(this.brand)) {
                    this.hasError_brand = false;
                }
                if (!isEmpty(this.code)) {
                    this.hasError_code = false;
                }
                if (!isEmpty(this.in_A)) {
                    this.hasError_in_A = false;
                }
                if (this.isPoleNumVisible && !isEmpty(this.poleNumber)) {
                    this.hasError_poleNumber = false;
                    this.emptyWarning_poleNumber = '';
                }
                if (this.is_sbt_cekmeceliVisible && !isEmpty(this.sbt_cekmeceli)) {
                    this.hasError_sbt_cekmeceli = false;
                    this.emptyWarning_sbt_cekmeceli = '';
                }
                if (this.isPowerVisible && !isEmpty(this.power)) {
                    this.hasError_power = false;
                    this.emptyWarning_power = '';
                }
            },
            controlInputs_3() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate_3 = false;
                if (isEmpty(this.connType)) {
                    this.hasError_connType = true;
                } else if (this.isCablePosVisible && isEmpty(this.cablePos)) {
                    this.hasError_cablePos = true;
                } else if (isEmpty(this.phaseNumber_conductor)) {
                    this.hasError_phaseNumber_conductor = true;
                } else if (isEmpty(this.conductorDimension)) {
                    this.hasError_conductorDimension = true;
                } else if (!(parseFloat(this.conductorLength) > 0)) {
                    this.hasError_conductorLength = true;
                } else {
                    this.canCalculate_3 = true;
                }

                if (!isEmpty(this.connType)) {
                    this.hasError_connType = false;
                }
                if (!isEmpty(this.cablePos)) {
                    this.hasError_cablePos = false;
                }
                if (!isEmpty(this.phaseNumber_conductor)) {
                    this.hasError_phaseNumber_conductor = false;
                }
                if (!isEmpty(this.conductorDimension)) {
                    this.hasError_conductorDimension = false;
                }
                if (parseFloat(this.conductorLength) > 0) {
                    this.hasError_conductorLength = false;
                }
            },
            controlInputs_4() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate_4 = false;
                if (isEmpty(this.connType_2)) {
                    this.hasError_connType_2 = true;
                } else if (this.isCablePosVisible_2 && isEmpty(this.cablePos_2)) {
                    this.hasError_cablePos_2 = true;
                } else if (isEmpty(this.phaseNumber_conductor_2)) {
                    this.hasError_phaseNumber_conductor_2 = true;
                } else if (isEmpty(this.conductorDimension_2)) {
                    this.hasError_conductorDimension_2 = true;
                } else if (!(parseFloat(this.conductorLength_2) > 0)) {
                    this.hasError_conductorLength_2 = true;
                } else {
                    this.canCalculate_4 = true;
                }

                if (!isEmpty(this.connType_2)) {
                    this.hasError_connType_2 = false;
                }
                if (!isEmpty(this.cablePos_2)) {
                    this.hasError_cablePos_2 = false;
                }
                if (!isEmpty(this.phaseNumber_conductor_2)) {
                    this.hasError_phaseNumber_conductor_2 = false;
                }
                if (!isEmpty(this.conductorDimension_2)) {
                    this.hasError_conductorDimension_2 = false;
                }
                if (parseFloat(this.conductorLength_2) > 0) {
                    this.hasError_conductorLength_2 = false;
                }
            },
            openCircuitDevices() {
                this.$store.state.previousRoute = this.$route.name;
                this.$store.state.isCircDevicesFromCalculation = true;
                if (this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1) {
                    router.push('/circuitDevices_Admin');
                } else {
                    router.push('/circuitDevices');
                }
            },
            openInfo() {
                if (!this.isInfoOpened) {
                    this.isInfoOpened = true;
                } else {
                    this.isInfoOpened = false;
                }
            }
        },

    };
</script>
